import { Component, ViewChild, Renderer } from '@angular/core';
import { NavController, Slides, ViewController, NavParams, MenuController  } from 'ionic-angular';
import { CustomAlert } from '../../components/custom-alert.component';
import { Storage } from '@ionic/storage';
import {BrowserModule, DomSanitizer} from '@angular/platform-browser'

//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { SearchProvider } from '../../providers/search-provider';
import { GeralProvider } from '../../providers/geral-provider';
import { Congresso } from '../../models/congresso.model';
import { TabsPage } from '../tabs/tabs';

@Component({
    selector: 'page-ajuda',
    templateUrl: 'ajuda.html'
})

export class AjudaPage {

    @ViewChild(Slides) slides: Slides;
    public firstAccess = true;
    private congresso: Congresso;
    public isCongressoLoad: boolean;

    private slidesContent = [{
        image: "assets/images/help-menu-principal.gif",
        title: "Menu Principal",
        desc: "O <strong>menu principal</strong> do aplicativo fica disponível na parte inferior, <strong>clique no item desejado</strong> para acessar o conteúdo.",
    }, {
            image: "assets/images/help-menu-lateral.gif",
            title: "Menu Lateral",
            desc: "No topo à direita da tela, <strong>clique</strong> ou<strong> arraste para esquerda</strong> para acessar o <strong>menu lateral</strong> do aplicativo com <strong>opções adicionais</strong>.",
        }, {
            image: "assets/images/help-filtro.gif",
            title: "Filtro de Atividades",
            desc: "No <strong>menu agenda</strong>, clicando no <strong>botão de filtro</strong>, você poderá definir sua busca por <strong>sala</strong>, <strong>horário</strong> ou <strong>disponibilidade</strong> de vagas.",
        }, {
            image: "assets/images/help-aulas.gif",
            title: "Inscrição em Atividades",
            desc: "Para se <strong>inscrever</strong> em uma atividade, <strong>clique no botão inscreva-se</strong>, e para <strong>cancelar</strong> sua inscrição em uma atividade, <strong>clique no botão novamente</strong>.",
        }, {
            image: "assets/images/help-favoritos.gif",
            title: "Palestrantes Favoritos",
            desc: "<strong>Clique na estrela</strong> ou <strong>deslize o dedo para esquerda</strong> para marcar um palestrante como favorito no aplicativo.",
        }, {
            image: "assets/images/help-palestrantes-filtro.gif",
            title: "Filtro de Palestrantes",
            desc: "No <strong>menu palestrantes</strong>, você pode realizar buscas por <strong>palavra-chave</strong> ou <strong>clicar na estrela</strong> e visualizar seus <strong>palestrantes favoritos</strong>.",
        }, {
            image: "assets/images/help-videos.gif",
            title: "Assista Aulas",
            desc: "Para assistir as aulas dos congressos anteriores, clique no <strong>botão assistir </strong>sempre que disponível (sócios podem assistir qualquer vídeo).",
        }, {
            image: "assets/images/help-modal-congresso.gif",
            title: "Congressos Anteriores",
            desc: "No <strong>menu lateral</strong>, clicando em <b>congressos</b>, você pode escolher o congresso que deseja visualizar o conteúdo.",
        }, {
            image: "assets/images/help-congressos-anteriores.gif",
            title: "Congresso Atual",
            desc: "Quando estiver visualizando um <strong>congresso anterior</strong>, no<strong> menu principal</strong>, será disponibilizado um botão para <strong>voltar para o congresso atual</strong>.",
        }, {
            image: "assets/images/help-modal-alerta.gif",
            title: "Alerta de Aulas",
            desc: "No <strong>menu lateral</strong>, clicando no botão <b>alerta de aula</b>, você pode definir como deseja ser <strong>notificado</strong> nas atividades inscritas.",
        }]

    constructor(public navCtrl: NavController,
        private menuCtrl: MenuController,
        private alert: CustomAlert,
        private configProvider: ConfigProvider,
        private utilProvider: UtilProvider,
        private searchProvider: SearchProvider,
        private navParams: NavParams,
        private congressoProvider: CongressoProvider,
        private geralProvider: GeralProvider,
        private sanitizer: DomSanitizer,
        public viewCtrl: ViewController) {
        this.firstAccess = localStorage.getItem('firstAccess') == 'true';
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.isCongressoLoad = false;
    }

    ionViewWillLoad(){
      //this.utilProvider.connected = this.utilProvider.isConnected(true);
    }

    finalizar() {
        this.menuCtrl.enable(true);
        if (this.firstAccess) {
            //Está sendo setado na home
            //localStorage.setItem('firstAccess','false');
            if (this.utilProvider.isConnected(true))
                this.navCtrl.push(TabsPage);
        }
        else
            this.viewCtrl.dismiss();
    }

    checkLoadCongresso(){
        let self = this;
        this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        if (this.congresso == null) {
            setTimeout(() => {self.checkLoadCongresso()}, 3000);
        }
    }

    platformIsIos() {
        return this.utilProvider.getPlatform() == 'ios';
    }

    ionViewDidEnter() {
        this.checkLoadCongresso();
        this.menuCtrl.enable(false);
    }
}



// WEBPACK FOOTER //
// ./src/pages/ajuda/ajuda.ts